<div class="modal-header">
  <h4 class="modal-title pull-left"> Mon compte </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="height: auto; padding: 1px 0">
  <div class="col-sm-12 p-3">
    <div class="col-sm-12" *ngIf="errorForm">
      <p  class="password-criteria__item ml-2" style="margin-top: 5px; display: inline-block;">    {{ errorForm }}</p>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-4" style="padding: 0;"> Nom <span class="champobligatoire"> * </span> : </label>
      <input type="text" class="col-sm-8 form-control" [(ngModel)]="user.nom">
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-4" style="padding: 0;"> Prénom <span class="champobligatoire"> * </span> : </label>
      <input type="text" class="col-sm-8 form-control" [(ngModel)]="user.prenom">
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-4" style="padding: 0;"> Mail <span class="champobligatoire"> * </span> : </label>
      <input type="text" class="col-sm-8 form-control" [(ngModel)]="user.mail">
    </div>
    <div class="password-criteria col-sm-12" *ngIf="errorPwd">
      <h5 class="password-criteria__title">Votre mot de passe doit respecter les règles suivantes :</h5>
      <ul>
        <li class="password-criteria__item">
          Avoir une longueur minimum de 12 caractères
        </li>
        <li class="password-criteria__item">
          Contenir au moins une majuscule
        </li>
        <li class="password-criteria__item">
          Contenir au moins une minuscule
        </li>
        <li class="password-criteria__item">
          Contenir au moins un chiffre
        </li>
        <li class="password-criteria__item">
          Contenir au moins un caractère spécial
        </li>
      </ul>
    </div>
    <div class="col-sm-12 p-0" *ngIf="!isSSO">
      <div class="form-group col-sm-12">
        <label class="col-sm-4" style="padding: 0;"> Anciens mot de passe :
        </label>
        <input class="form-control col-sm-8" [type]="getPasswordType('oldPassword')" [(ngModel)]="user.oldPassword.value" placeholder="*******"
           />
        <span class="eye-icon" (click)="togglePasswordVisibility('oldPassword')">
          <i class="fa" [ngClass]="{'fa-eye': !user.oldPassword.showPassword, 'fa-eye-slash': user.oldPassword.showPassword}"></i>
        </span>
      </div>
      <div class="form-group col-sm-12">
        <label class="col-sm-4" style="padding: 0;"> Nouveau mot de passe  :
        </label>
        <input class="form-control col-sm-8" [type]="getPasswordType('pwd')" [(ngModel)]="user.pwd.value" placeholder="*******"/>
        <span class="eye-icon" (click)="togglePasswordVisibility('pwd')">
          <i class="fa" [ngClass]="{'fa-eye': !user.pwd.showPassword, 'fa-eye-slash': user.pwd.showPassword}"></i>
        </span>
      </div>
      <div class="form-group col-sm-12">
        <label class="col-sm-4" style="padding: 0;"> Retaper le nouveau mot de passe  : </label>
        <input class="form-control col-sm-8" [type]="getPasswordType('mdpconfirm')" [(ngModel)]="user.mdpconfirm.value" placeholder="*******"/>
        <span class="eye-icon" (click)="togglePasswordVisibility('mdpconfirm')">
          <i class="fa" [ngClass]="{'fa-eye': !user.mdpconfirm.showPassword, 'fa-eye-slash': user.mdpconfirm.showPassword}"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="text-right col-sm-12" style="margin: 10px 0;">
    <button type="button" class=" btn-close ml-2" (click)="common.closeModal(); "> Annuler </button>
    <button type="button" class="btn btn-close btn-valider ml-2" (click)="saveInfo()"> Enregistrer </button>
  </div>
</div>